<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="입력" icon="pi pi-pencil" class="p-button-success mr-2" @click="btnAct('NEW')" />
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="저장" icon="pi pi-save" class="p-button-success mr-2" @click="btnAct('SAVE')" :disabled="!selectedItems || !selectedItems.length" />
            <Button label="행삭제" icon="pi pi-minus" class="p-button-success mr-2" @click="btnAct('ROWDELETE')" :disabled="!selectedItems || !selectedItems.length" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="compSeq" v-model="searchParams.compSeq" :options ="compCodes" optionLabel="codeNm" optionValue="code" required="true" :showClear="true" style="width: 11rem"/>
                        <label for="compSeq">센터명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="calcYm" v-model="searchParams.calcYm" :options="calcYms" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem" scrollHeight="20em" :editable="true"/>
                        <label for="calcYm">평가년도</label>
                    </div>
                </div> 
            </template>
        </Toolbar>
        
        <DataTable id="dt" ref="dt" :value="dataList" v-model:selection="selectedItems" showGridlines 
            editMode="cell" @cell-edit-complete="onCellEditComplete" 
            scrollable="true" scrollHeight="79vh" class="p-datatable-sm" responsiveLayout="scroll">
            <Column header="No" style="min-width:3em; max-width:3em" exportFooter=" ">
                <template #body="{index}">
                    {{ index + 1 }}
                </template>    
            </Column>
            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false" exportFooter=" "></Column>
            <Column field="calcYm" header="평가년도" :sortable="false" exportFooter=" "></Column>
            <Column field="calcCnt" header="평가차수" :sortable="false" exportFooter=" "></Column>
            <Column field="calcFrYmd" header="평가대상시작일" :sortable="false" exportFooter=" ">
                <template #body="{ data, field }">
                    {{ convertDateString(data[field]) }}
                </template>
                <template #editor="{ data, field }">
                    <Calendar v-model="data[field]"  :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar :showIcon="true" style="width: 10rem"/>
                </template>
            </Column>
            <Column field="calcToYmd" header="평가대상종료일" :sortable="false" exportFooter=" ">
                <template #body="{ data, field }">
                    {{ convertDateString(data[field]) }}
                </template>
                <template #editor="{ data, field }">
                    <Calendar v-model="data[field]"  :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar :showIcon="true" style="width: 10rem"/>
                </template>
            </Column>
            <Column field="calcDays" header="평가일수" :sortable="false" exportFooter=" "></Column>
            <Column field="gaSuppAmt" header="유가보조금" :sortable="false" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" inputStyle="max-width: 10em"/>
                </template>
            </Column>
            <Column field="busSuppAmt" header="저상버스운영지원비" :sortable="false" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" inputStyle="max-width: 10em"/>
                </template>
            </Column>
            <Column field="apprInst" header="평가기관" :sortable="false" exportFooter=" ">
                <template #editor="{ data, field }">
                    <InputText v-model="data[field]" style="width: 8em"/>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import MA201060Service from '@/service/ma/MA201060Service';
import CustService from '@/service/ma/CustService';
import JsUtils from '@/utilities/JsUtils';

export default {
    setup() {
        onMounted(() => {
            year.value = new Date().getFullYear();
            calcYms.value = Array.from({ length: year.value - 2010 + 1 }, (_, i) => ({ codeNm: `${year.value - i}`, code: year.value - i }));

            searchParams.compSeq = 1;
            custService.getCodeList(searchParams).then(data => {
                corps.value = data;
            });
        })
        const ma201060Service = new MA201060Service();
        const custService = new CustService();
        const searchParams = reactive({calcYm:null, calcCnt:null, corpId:null});
        const dataList = ref([]);
        const selectedItems = ref([]);
        const corps = ref([]);
        const rowIndex = ref(null);
        const confirm = useConfirm();
        const toast = useToast();
        const loading = ref(false);
        const editingRows = ref([]);
        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        const compCodes = ref([
            {codeNm: '경남도청', code: 1},
        ]);
        const year = ref();
        const calcYms = ref([]);

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "NEW": {
                        // 검색조건에 관할행정, 업체명이 있는 지 확인한다
                        if(!JsUtils.checkUndefineColumns(searchParams, ["compSeq","calcYm"])){
                            toast.add({severity:'warn', summary:'필수입력 확인', detail:'센터명과 평가년도는 필수 입력 하셔야 합니다.', life:2000});
                            return true;
                        }

                        var _ = require('lodash');

                        let _row = _.find(dataList.value, function(obj) {
                            if ( obj.calcCnt === undefined || obj.calcCnt === null  ) {
                                return true;
                            }
                        });

                        if(_row != null && _row != undefined) {
                            toast.add({severity:'warn', summary:'입력확인', detail:'현재 목록에 저장 되어 있지 않은 신규 입력 목록 건이 있습니다.', life:2000});
                                return true;
                        } 

                        // 현재 목록의 첫번째 row에 신규 행을 추가한다
                        //let _ = require('lodash');
                        //let _corpNm = _.find(custCodes.value, {'code': searchParams.corpId}).codeNm;
                        // 검색조건에 시작일자,종료일자를 표시한다
                        let date = new Date();  
                        let fromDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
                        fromDate = JsUtils.getDateString(fromDate);            
                        let Edate = JsUtils.getDateString(new Date());          // 현재 일자

                        let date1 = new Date(fromDate);
                        let date2 = new Date(Edate);
                        let diffDate = date2.getTime() - date1.getTime();
                        let calcDay = Math.abs(diffDate / (1000 * 60 * 60 * 24)) + 1;

                        dataList.value.unshift({publicId:searchParams.publicId, calcYm:searchParams.calcYm, 
                            gaSuppAmt:0, busSuppAmt:0, calcFrYmd:fromDate, calcToYmd:Edate, calcDays:calcDay});
                    
                        // 목록의 첫번째 row를 편집 상태로 변경한다
                        editingRows.value = [...editingRows.value, dataList.value[0]];                    
                        break;  
                    }
                case "SEARCH":
                    searchList();
                    break;
                case "SAVE":
                    saveList();
                    break; 
                case "ROWDELETE":
                    deleteList();
                    break;                     
                default:
            }
        }

        const searchList = () => {

            loading.value = true;
            ma201060Service.getList(searchParams).then(data => {
                 if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000}); 
                dataList.value = data;
            }).finally(() => {
                loading.value = false;
            });
        };

        const saveList = () => {
            confirm.require({
                message:'선택된 항목(들)을 저장하시겠습니까?',
                header: '저장',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    // selectedItems.value.forEach(row => {
                    //     //row.useYn = row.useYn == true ? 'Y' : 'N';    // Checkbox는 true or fale 값을 가지므로 Y' or 'N'으로 변환한다
                    // });

                    ma201060Service.updateList(selectedItems.value).then(() => {
                        // Datatable에서 선택된 행들을 초기화 한다
                        selectedItems.value = [];
                        searchList();
                        toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                    })
                    .catch(error => {
                        if (error.response) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 3000});
                        } else if (error.request) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 3000});	
                        } else {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 3000});	
                        }
                    });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            });
        };

        const deleteList = () => {
            confirm.require({
                message:'선택된 항목(들)을 삭제하시겠습니까?',
                header: '삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    ma201060Service.deleteList(selectedItems.value).then(() => {
                        // Datatable에서 선택된 행들을 초기화 한다
                        selectedItems.value = [];
                        searchList();
                        toast.add({severity:'success', summary: '완료', detail: '삭제 완료', life: 3000});
                    })
                    .catch(error => {
                        if (error.response) {
                            toast.add({severity:'error', summary: '삭제 오류', detail: error.response.data.message, life: 3000});
                        } else if (error.request) {
                            toast.add({severity:'error', summary: '삭제 오류', detail: error.request.data, life: 3000});	
                        } else {
                            toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                        }
                    });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            });
        };

        // 셀 편집 후, Datatable의 해당 행(Row)를 선택된 상태로 만든다
        const onCellEditComplete = (event) => {
            let { data, newValue, field } = event;
            if(data[field] === newValue) return;

            switch (field) {
                case "calcDays":
                case "calcFrYmd":  // 평가대상시작일
                case "calcToYmd": { // 평가대상종료일
                   
                    data[field] = JsUtils.convertDateToString(newValue);    // yyyymmdd 형식을 yyyy-mm-dd 형식으로 표시한다

                    let date1 = new Date(data['calcFrYmd']);
                    let date2 = new Date(data['calcToYmd']);
                    let diffDate = date2.getTime() - date1.getTime();
                    let calcDay = Math.abs(diffDate / (1000 * 60 * 60 * 24));
                    data.calcDays = calcDay + 1;
                    //alert(data.calcDays);
                    break;
                }
                case "gaSuppAmt": // 유가보조금
                case "busSuppAmt": // 저상버스운영지원비
                case "apprInst": {  // 평가기관
                    data[field] = newValue;
                    break;
                }
                default:
                    break;
            }

            // 기존에 추가된 행이 아닌 경우에만 선택된 행 목록에 추가한다
            // 해당 Row를 유일하게 구분할 수 있는 값 사용
            var _ = require('lodash');
            // const _row = _.find(selectedItems.value, {'calcFrYmd': data.calcFrYmd, 'calcToYmd': data.calcToYmd, 
            //     'calcYm': data.calcYm, 'calcCnt': data.calcCnt});

            let _row = _.find(selectedItems.value, function(obj) {
                if (obj.calcFrYmd === data.calcFrYmd 
                    && obj.calcToYmd === data.calcToYmd
                    && obj.calcYm === data.calcYm
                    && obj.calcCnt === data.calcCnt ) {
                    return true;
                }
            });

            if(_row == null || _row == undefined) {
                selectedItems.value.push(data);
            }
        };

        // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
            var num = Number(value).toFixed(0);
            return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        const convertDateString = (data) => {
            return JsUtils.convertDateString(data);
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, dataList.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(dataList.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        return { 
            dt, dataList, selectedItems, searchParams, corps, rowIndex, compCodes, calcYms, year, loading,
            btnAct, searchList, saveList, deleteList, formatToPrice, downloadExcel, exportCSV, onCellEditComplete, convertDateString,
        }

    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
